import { gql } from "@apollo/client";

// auth mutaions
export const LOGIN = gql`
  mutation UserLogin($email: String!, $password: String!) {
    login(loginUser: { email: $email, password: $password }) {
      access_token
      refresh_token
      acl
    }
  }
`;

export const REFRESH_TOKEN = gql`
  mutation RefreshToken($token: String!) {
    refreshToken(token: $token) {
      access_token
      refresh_token
    }
  }
`;

export const LOGOUT = gql`
  mutation Logout($token: String) {
    logout(token: $token) {
      status
      message
    }
  }
`;

// [Mutation] for forgot password
export const FORGOT_PASSWORD = gql`
  mutation ForgotPassword($email: String!) {
    forgotPassword(email: $email) {
      message
      status
    }
  }
`;

//[Mutation] for reset password
export const RESET_PASSWORD = gql`
  mutation ResetPassword($password: String!, $userKey: String!) {
    updatePassword(payload: { password: $password, userKey: $userKey }) {
      message
      status
    }
  }
`;
